import { Flex, Loader } from "@fluentui/react-northstar";
import React from "react";
import { useTranslation } from "react-i18next";

import { PageHeader } from "../../page-header/pageHeader";

import { HeaderTypes } from "./ResultsHeader.types";
import { ResultsHeaderProps } from "./ResultsHeader.types";
import { useResultsHeaderStyles } from "./ResultsHeader.styles";

export const ResultsHeader: React.FC<ResultsHeaderProps> = ({
  headerMessageType,
}) => {
  const resultsHeaderStyles = useResultsHeaderStyles();
  const { t } = useTranslation();

  if (headerMessageType === HeaderTypes.MISSING_DEVICES) {
    return (
      <PageHeader
        headerStyles={resultsHeaderStyles.headingLabel}
        headerContent={t("RESULTS_PAGE_HEADER_MISSING_DEVICES")}
        descriptionStyles={resultsHeaderStyles.descriptionLabel}
        descriptionContent={t(
          "RESULTS_PAGE_HEADER_MISSING_DEVICES_DESCRIPTION"
        )}
      />
    );
  } else if (headerMessageType === HeaderTypes.FETCHING_DEVICE_INFO_MOBILE) {
    return (
      <Flex column>
        <Loader
          size="small"
          styles={resultsHeaderStyles.loader}
          aria-label={t("FETCHING_DEVICES_LOADER_A11Y_LABEL")}
        />
        <PageHeader
          headerStyles={resultsHeaderStyles.headingLabel}
          headerContent={t("RUNNING_TEST_HEADER")}
          descriptionStyles={resultsHeaderStyles.descriptionLabel}
          descriptionContent={t("RUNNING_TEST_DESCRIPTION")}
        />
      </Flex>
    );
  } else if (headerMessageType === HeaderTypes.FETCHING_DEVICE_INFO_DESKTOP) {
    return (
      <Flex column>
        <Loader
          size="medium"
          styles={resultsHeaderStyles.loader}
          aria-label={t("FETCHING_DEVICES_LOADER_A11Y_LABEL")}
        />
        <PageHeader
          headerStyles={resultsHeaderStyles.headingLabel}
          headerContent={t("RUNNING_TEST_HEADER")}
          descriptionStyles={resultsHeaderStyles.descriptionLabel}
          descriptionContent={t("RUNNING_TEST_DESCRIPTION")}
        />
      </Flex>
    );
  } else {
    return (
      <PageHeader
        headerStyles={resultsHeaderStyles.headingLabel}
        headerContent={t("NO_ISSUES_HEADER")}
        descriptionStyles={resultsHeaderStyles.descriptionLabel}
        descriptionContent={t("NO_ISSUES_DESCRIPTION")}
      />
    );
  }
};
